import { slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { utils, ListItem, Checkbox, ListItemText } from '@costar/theme-ui';
import React, { useState, useEffect, useCallback } from 'react';
import { useSelectKeyNavContext } from './select-key-nav-context.esm.js';
import { getOptionKey, isSelectOptionItem } from './utils.esm.js';

var DefaultItem = function DefaultItem(props) {
  var showSelectCheckBox = props.showSelectCheckBox,
    isMultiSelect = props.isMultiSelect,
    allSelected = props.allSelected,
    selectionClick = props.selectionClick,
    handleClose = props.handleClose,
    selection = props.selection,
    _props$resolveCurrent = props.resolveCurrentItem,
    resolveCurrentItem = _props$resolveCurrent === void 0 ? function (key) {
      return "".concat(key);
    } : _props$resolveCurrent,
    groupKey = props.groupKey,
    item = props.item,
    idx = props.idx;
  var _useSelectKeyNavConte = useSelectKeyNavContext(),
    hoverEventObserver = _useSelectKeyNavConte.hoverEventObserver;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  useEffect(function () {
    var hoverEventObserverHandler = function hoverEventObserverHandler(key) {
      if (getOptionKey(item, groupKey) === "".concat(key)) {
        setActive(true);
      } else {
        setActive(false);
      }
    };
    hoverEventObserver === null || hoverEventObserver === void 0 ? void 0 : hoverEventObserver.attach(hoverEventObserverHandler);
    return function () {
      return hoverEventObserver === null || hoverEventObserver === void 0 ? void 0 : hoverEventObserver.detach(hoverEventObserverHandler);
    };
  }, [groupKey, hoverEventObserver, item, setActive]);
  var handleMouseOver = useCallback(function () {
    hoverEventObserver === null || hoverEventObserver === void 0 ? void 0 : hoverEventObserver.notify(getOptionKey(item, groupKey));
  }, [groupKey, hoverEventObserver, item]);
  var handleClick = function handleClick(shouldEmitSelection, shouldHandleClose) {
    return function (event) {
      event.preventDefault();
      shouldEmitSelection && selectionClick(getOptionKey(item, groupKey))();
      shouldHandleClose && handleClose();
    };
  };
  var currentItem = resolveCurrentItem(item);
  var stringNodes = isSelectOptionItem(currentItem) ? utils.extractStringNodes(React.Children.toArray(currentItem.label).filter(function (i) {
    return typeof i === 'string';
  })) : [];
  var renderNodes = isSelectOptionItem(currentItem) ? React.Children.toArray(currentItem.label).filter(function (i) {
    return typeof i !== 'string' && typeof i !== 'undefined' && typeof i !== 'number' && typeof i !== 'boolean';
  }) : [];
  var label = typeof currentItem === 'string' ? currentItem : stringNodes.length > 0 ? "".concat(stringNodes) : undefined;
  var isSelected = allSelected || (Array.isArray(selection) ? selection.includes(getOptionKey(item, groupKey)) : getOptionKey(item, groupKey) === "".concat(selection));
  return /*#__PURE__*/React.createElement(ListItem, {
    key: "list-item-".concat(idx),
    active: active,
    selected: isSelected,
    onClick: handleClick(typeof currentItem === 'string' || !currentItem.disable && !currentItem.isNav, !isMultiSelect || isSelectOptionItem(currentItem) && currentItem.isNav),
    disabled: typeof currentItem === 'string' ? false : currentItem.disable,
    onMouseEnter: handleMouseOver
  }, showSelectCheckBox && /*#__PURE__*/React.createElement(Checkbox, {
    variant: "primary",
    checked: isSelected,
    active: active
  }), /*#__PURE__*/React.createElement(ListItemText, _extends({}, isSelectOptionItem(currentItem) && currentItem.getListTextProps ? currentItem.getListTextProps() : {}, {
    primary: label || (renderNodes.length > 0 ? renderNodes : null)
  })));
};
var defaultRenderItem = function defaultRenderItem(showSelectCheckBox, isMultiSelect, allSelected) {
  return function (selectionClick, handleClose, selection) {
    var resolveCurrentItem = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (key) {
      return "".concat(key);
    };
    var groupKey = arguments.length > 4 ? arguments[4] : undefined;
    return function Item(item, idx) {
      return /*#__PURE__*/React.createElement(DefaultItem, {
        key: "select-item-".concat(groupKey, "-").concat(item),
        showSelectCheckBox: showSelectCheckBox,
        isMultiSelect: isMultiSelect,
        allSelected: allSelected,
        selectionClick: selectionClick,
        handleClose: handleClose,
        selection: selection,
        resolveCurrentItem: resolveCurrentItem,
        groupKey: groupKey,
        item: item,
        idx: idx
      });
    };
  };
};

export default defaultRenderItem;
//# sourceMappingURL=render-default-item.esm.js.map
